<script lang="ts">
	import SectionInformationBlock from '$lib/components/Contentblocks/SectionInformationBlock.svelte';
	import { classes } from '$lib/utils';
	import { getTranslate } from '@tolgee/svelte';
	import CourseTrailer from '../CourseTrailer.svelte';

	export let lessons: Array<any>;
	export let courseSlug: string;
	export let trailerThumbnail: string = '';
	export let additionalClass = '';
	export let description = '';

	const { t } = getTranslate();

	$: sectionTitle = $t('section-title.overview.course-detail');
	$: title = $t('title.overview.course-detail');
</script>

{#if lessons && lessons.length > 0}
	<SectionInformationBlock
		additionalClass={classes(additionalClass, '')}
		{sectionTitle}
		{title}
		{description}
	>
		<div class="w-full max-w-[54rem] col-span-12 md:col-span-8">
			<CourseTrailer
				additionalClass="min-w-full max-w-fit"
				showHeadline={true}
				elementId="trailer-section"
				trailerUrl={lessons?.[0]?.streamUrl || ''}
				title={lessons?.[0]?.name ?? ''}
				id={lessons?.[0]?.id ?? ''}
				overlayTitle={lessons?.[1]?.name || 'NEXT LESSON'}
				overlayHref={`${courseSlug}/${lessons[1]?.slug}` || ''}
				{trailerThumbnail}
			/>
		</div>
	</SectionInformationBlock>
{/if}
